import { createAction, createReducer } from 'redux-act';

import { ISiteSettings } from '@sravni/types/lib/sitesettings';

const initialState: ISiteSettings = {
  header: {
    menu: undefined,
    mobileMenu: undefined,
  },
  footer: {
    menu: undefined,
    socialLinks: undefined,
    support: undefined,
  },
};

export const setSettings = createAction<ISiteSettings>('sitesettings/set');

export default createReducer({}, initialState).on(setSettings, (_, data) => data);
